import React from 'react';
import { Grid } from 'react-bootstrap';
import Notification from 'react-notify-toast';

import Header from './Header';
import Footer from './Footer';
import "./index.less";

const Main = ({children}) => (
  <div id="wrapper">
    <div className="wrapper">
      <Header />
      <div className="main-content">
        <Grid>{children}</Grid>
      </div>
    </div>
    <Footer />
    <Notification options={{ zIndex: 5000 }} />
  </div>
);

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/index.js